export default {
  name: 'rate',
  type: 'action',
  isRequired: true,
  essential: false
}
